module.exports = __webpack_public_path__ + "img/mh2.4cfb3df5.jpg";